import { useQuery, type NotifyOnChangeProps } from '@tanstack/react-query';
import { showOrganizationSeatUsageContract, type SeatUsageResponse } from '@bliks-io/contracts';
import { apiClient } from '../client';
import { seatUsageKeys } from '../query-keys';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Seat caps and headcounts of the signed-in user's own tenant.
 *
 * `options` is spread AFTER `enabled`, so a caller can tighten the freshness
 * rules (the seat-overrun lock page must never repair against a cached
 * under-cap reading) without re-spelling the token gate.
 */
export function useOrganizationSeatUsage(options?: {
  refetchOnMount?: boolean | 'always';
  notifyOnChangeProps?: NotifyOnChangeProps;
}) {
  const { token } = useAuthStore();

  return useQuery({
    queryKey: seatUsageKeys.organization(),
    queryFn: async ({ signal }): Promise<SeatUsageResponse['data']> => {
      const { data } = await apiClient.get<SeatUsageResponse>(
        showOrganizationSeatUsageContract.path,
        { signal }
      );
      return data.data;
    },
    enabled: !!token,
    ...options
  });
}
